import { render } from "./Terms.vue?vue&type=template&id=acc0b1fa&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=acc0b1fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc0b1fa"]])

export default __exports__